export default "__VITE_ASSET__eHlJiRFl__"